export default __webpack_public_path__ + "static/media/curriculo.09aeac90.png";